import {
  ROUTE_2BAP_EXTERNAL_LEARNERS_MODULE_SUMMARY_VIEW
} from 'constants/routePath';

export class LearnersRouterHelper {

  static SUMMARY_VIEW_PATH = ROUTE_2BAP_EXTERNAL_LEARNERS_MODULE_SUMMARY_VIEW;

}
